<template>
  <div class="foslink-footer">
    <div class="w-1200">
      <div class="footer-top">
        <div class="footer-logo">
          <div>
            <img :src="logo" alt="">
            <div class="logo-title">云安智消</div>
          </div>
          <div class="footer-link">
            <div><p>联系电话</p></div>
            <div class="footer-phone"><p>17810692946</p></div>
          </div>
          <!-- <p>举报电话：010-65009693</p> -->
        </div>
        <!-- <div class="footer-menu">
          <div class="footer-title">功能导航</div>
          <div class="menu-list-f">
            <ul class="footer-m-list">
              <li :class="{ 'is-active': activeName == item.name }" v-for="(item, index) in menuList1" :key="index"><span
                  class="menu-title" @click="goPage(item)">{{ item.title }}</span></li>
            </ul>
            <ul class="footer-m-list">
              <li :class="{ 'is-active': activeName == item.name }" v-for="(item, index) in menuList2" :key="index"><span
                  class="menu-title" @click="goPage(item)">{{ item.title }}</span></li>
            </ul>
          </div>
        </div> -->
        <div class="footer-menu" v-if="false">
          <div class="footer-title">关注我们</div>
          <div class="footer-ewm">
            <div>
              <img src="/images/wx.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bootom"> COPYRIGHT 2017-2025 © 2025 北京唯品超越电气技术有限公司
        <a target="_blank" href="https://beian.miit.gov.cn">京ICP备2025110035号-1</a>
        <!-- <a style="margin-left: 5px;" target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch">
          <img src="/images/beian-icon.png" style="position: relative; top: 4px;" />京公网安备11011102002615号</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "./common"
const logo = '/images/logo.png'
export default {
  data() {
    return {
      logo,
      menuList,
      activeName: '',
    }
  },
  watch: {
    $route: {
      handler(n, o) {
        this.initPage()
      },
      deep: true
    }
  },
  computed: {
    menuList1() {
      return this.menuList.slice(0, 3)
    },
    menuList2() {
      return this.menuList.slice(3)
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    initPage() {
      let routeName = this.$route.name
      if (routeName === 'productDetails' || routeName === 'bigDanger' || routeName === 'maintenance') {
        let type = this.$route.query.type
        if (type == 2) {
          this.activeName = 'home'
        } else {
          this.activeName = 'product'
        }
      } else if (routeName === 'prdTrain' || routeName === 'longControl') {
        this.activeName = 'product'
      } else if (routeName === 'caseDetails') {
        this.activeName = 'case'
      } else if (routeName === 'deviceInfo') {
        this.activeName = 'device'
      } else if (routeName === 'apply') {
        this.activeName = 'maintenance'
      } else if (routeName === 'deviceInfoHome') {
        this.activeName = 'home'
      } else if (routeName === 'remoteControl') {
        let type = this.$route.query.type
        if (type == 1) {
          this.activeName = 'remoteControl'
        } else {
          this.activeName = 'product'
        }
      } else {
        this.activeName = this.$route.name
      }
    },
    goPage(item) {
      this.$router.push({ path: item.path })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/menu.scss';
</style>


// WEBPACK FOOTER //
// src/views/components/AppFooter.vue